import { useState, useEffect } from "react";
import { Capacitor } from "@capacitor/core";

/**
 * Monitors network connectivity on native platforms.
 * Returns isOnline status, falling back to navigator.onLine on web.
 */
export const useNetworkStatus = () => {
  const [isOnline, setIsOnline] = useState(true);

  useEffect(() => {
    if (Capacitor.isNativePlatform()) {
      let listener: any;

      const setup = async () => {
        const { Network } = await import("@capacitor/network");
        const status = await Network.getStatus();
        setIsOnline(status.connected);

        listener = await Network.addListener("networkStatusChange", (s) => {
          setIsOnline(s.connected);
        });
      };

      setup();
      return () => { listener?.remove?.(); };
    } else {
      // Web fallback
      const onOnline = () => setIsOnline(true);
      const onOffline = () => setIsOnline(false);
      setIsOnline(navigator.onLine);
      window.addEventListener("online", onOnline);
      window.addEventListener("offline", onOffline);
      return () => {
        window.removeEventListener("online", onOnline);
        window.removeEventListener("offline", onOffline);
      };
    }
  }, []);

  return { isOnline };
};
